export class SnackPerson {
  constructor(
    public name: string,
    public wantSnack: boolean,
    public hasRegistered: boolean) { }
}



// WEBPACK FOOTER //
// ./src/app/Model/SnackPerson.ts